module.exports = __webpack_public_path__ + "img/phone1.576eec60.png";